import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { NAV_HEIGHT, media } from '~/src/common/theme/styles-constants';

export const DeliveryContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  gap: 8px;
  width: 100%;

  border: none;

  height: ${NAV_HEIGHT}px;
  padding: 8px;

  ${media.XL`
    height: 32px;
    padding: 0;
  `}
`;

export const DeliveryButtonItem = styled.button<{ $isToComplete: boolean }>`
  height: 32px;
  margin: 0 auto;
  padding: 8px;

  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;

  border-radius: 4px;
  border: none;

  background-color: ${COLORS.GROUND_UNDERGROUND};
  color: ${COLORS.NEUTRAL_DEFAULT};

  font-size: 14px;
  font-weight: 500;

  max-width: 100%;
  overflow: hidden;

  cursor: pointer;

  /* button text */
  & > span:last-child {
    font-size: 14px;
    line-height: 16px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: ${COLORS.ACTION_HOVER};
    color: ${COLORS.NEUTRAL_WHITE};

    /* button icon */
    & > span:first-child {
      color: ${COLORS.NEUTRAL_WHITE};
    }
  }

  ${media.XL<{ $isToComplete: boolean }>`
    width: ${({ $isToComplete }) => ($isToComplete ? '256px' : '167.5px')};
  `}
`;
